<div>
    <div class="row pb-2">
        <div class="col"></div>
        <div class="col-auto">
            <button type="button" class="btn btn-primary" (click)="add(0)" [disabled]="isDisabled">
                <i class="bi bi-plus-lg" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Add Reason':'Loading...'}}
            </button>
        </div>
    </div>
    <div class="card border-radius-0 mt-1 p-0">
        <div class="card-header">
            Reason Master
        </div>
        <div class="card-body p-1">
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger" class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th>Reason Name</th>
                        <th style="width: 5px;" >Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let element of Reason">
                        <td> {{element['ResignationReason']}}</td>
                        <td style="width: 5px;">
                            <div class="text-center" [ngClass]="{'colHide': !this.common.PageRight.IsEdit}"><i (click)="add(element['ESS_ResignationReasonMasterId'])"
                                    class="bi bi-pencil-square text-warning"></i></div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>